import { render, staticRenderFns } from "./PageFrame.vue?vue&type=template&id=982cd242&scoped=true"
import script from "./PageFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFrame.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982cd242",
  null
  
)

export default component.exports